var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 7.5C23.925 7.5 15.9375 15.4875 15.9375 25.3125C15.9375 34.95 23.475 42.75 33.3 43.0875C33.6 43.05 33.9 43.05 34.125 43.0875C34.2 43.0875 34.2375 43.0875 34.3125 43.0875C34.35 43.0875 34.35 43.0875 34.3875 43.0875C43.9875 42.75 51.525 34.95 51.5625 25.3125C51.5625 15.4875 43.575 7.5 33.75 7.5Z",
    fill: "#00C897"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8001 53.0625C42.3376 46.0875 25.2751 46.0875 14.7376 53.0625C9.9751 56.25 7.3501 60.5625 7.3501 65.175C7.3501 69.7875 9.9751 74.0625 14.7001 77.2125C19.9501 80.7375 26.8501 82.5 33.7501 82.5C40.6501 82.5 47.5501 80.7375 52.8001 77.2125C57.5251 74.025 60.1501 69.7501 60.1501 65.1001C60.1126 60.4876 57.5251 56.2125 52.8001 53.0625Z",
    fill: "#00C897"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9626 27.5249C75.5626 34.7999 70.3876 41.1749 63.2251 42.0374C63.1876 42.0374 63.1876 42.0374 63.1501 42.0374H63.0376C62.8126 42.0374 62.5876 42.0374 62.4001 42.1124C58.7626 42.2999 55.4251 41.1374 52.9126 38.9999C56.7751 35.5499 58.9876 30.3749 58.5376 24.7499C58.2751 21.7124 57.2251 18.9374 55.6501 16.5749C57.0751 15.8624 58.7251 15.4124 60.4126 15.2624C67.7626 14.6249 74.3251 20.0999 74.9626 27.5249Z",
    fill: "#00C897"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4624 62.2125C82.1624 65.85 79.8374 69 75.9374 71.1375C72.1874 73.2 67.4624 74.175 62.7749 74.0625C65.4749 71.625 67.0499 68.5875 67.3499 65.3625C67.7249 60.7125 65.5124 56.25 61.0874 52.6875C58.5749 50.7 55.6499 49.125 52.4624 47.9625C60.7499 45.5625 71.1749 47.175 77.5874 52.35C81.0374 55.125 82.7999 58.6125 82.4624 62.2125Z",
    fill: "#00C897"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.540e7126b9916da022a20f30db14df61.svg";
export { ForwardRef as ReactComponent };